module.exports = __webpack_public_path__ + "img/appAsset--customer-address-ax.5fdc0e7c.svg";